export default "__VITE_ASSET__Dl494FkD__"